import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {InputField} from '../common/rc-fields';
import {GreatForm} from 'components/common';
import {createMessage} from 'api/messages';

const getMessageInitialValue = (reading) =>
  [
    `Book Title: ${!isEmpty(reading.book) ? reading.book.title : reading.bookTitle || 'N/A'}`,
    `Reaction: ${reading.reaction || 'N/A'}`,
    `Page: ${reading.page || 'N/A'}`,
    `Comment: ${reading.comment || 'N/A'}`,
  ].join('\n') + '\n\n';

const MessageForm = ({reading, receiver, form, onSubmitSuccess}) => {
  return (
    <GreatForm
      form={form}
      submitFn={(payload) =>
        createMessage({
          receiverId: receiver.id,
          receiverRole: receiver.role,
          ...payload,
        })
      }
      onSuccess={onSubmitSuccess}
      successMsg="Message has been successfully created!"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputField
            name="body"
            label="Please enter your message."
            initialValue={isEmpty(reading) ? '' : getMessageInitialValue(reading)}
            rules={[{required: true, message: 'Please enter a message'}]}
            form={form}
            variant="outlined"
            multiline
            rows={8}
            rowsMax={32}
          />
        </Grid>
      </Grid>
    </GreatForm>
  );
};

MessageForm.propTypes = {
  form: formShape.isRequired,
  bookId: PropTypes.string,
  reading: PropTypes.object.isRequired,
  receiver: PropTypes.object.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};

export default createForm()(MessageForm);
